export const PRODUCT_TYPE = {
  TICKET: "ticket",
  GOODS: "goods",
} as const;
